import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {CallbackComponent} from './components/callback/callback.component';
import { EmpresaRedirectComponent } from './components/empresa-redirect/empresa-redirect.component';

const routes: Routes = [
  {
    path: 'callback',
    component: CallbackComponent
  },
  // { path: 'shell', loadChildren: () => import('./shell/shell.module').then(m => m.ShellModule) },
  {path: 'home', loadChildren: './modules/home/home.module#HomeModule'},
  {path: 'shell', loadChildren: './shell/shell.module#ShellModule'},
  { path: ':alias', component: EmpresaRedirectComponent },
  {path: '', loadChildren: './modules/home/home.module#HomeModule', pathMatch: 'full'},
   // {path: '', loadChildren: () => import('./core/header/header.module').then(m => m.HeaderModule)},
  // { path: 'home', loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule) }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
